import styled from '@emotion/styled'

const SIDEBAR_WIDTH_PX = 280

/* The two columns are taken out of flow (see Layout) so they stop contributing their content height
   to ModuleContent, whose .simplebar-content grows with its content. This box then stretches to the
   space ModuleContent has left, giving both columns a definite height to fit into. */
export const DetailContent = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-height: 0;
  position: relative;
`

/* padding-bottom on this absolute box insets the columns from the viewport edge. Parent padding
   would not, because inset 0 sizes against DetailContent's padding edge. */
export const Layout = styled.div`
  display: flex;
  align-items: stretch;
  gap: var(--lumen-spacing-16);
  padding-bottom: var(--lumen-padding-24);
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  overflow-x: auto;
  overflow-y: hidden;
`

interface SidebarColumnProps {
  fullHeight?: boolean
}

export const SidebarColumn = styled.div<SidebarColumnProps>`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: ${SIDEBAR_WIDTH_PX}px;
  min-height: 0;
  position: sticky;
  top: 0;

  ${({ fullHeight }) =>
    fullHeight &&
    `
    height: 100%;
  `};
`

/* min-width: 0 lets the column shrink below the table's min-width instead of overflowing the row;
   the table's own scroll area takes over the horizontal scrolling from there. */
export const DetailColumn = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  min-width: 0;
  height: 100%;
  min-height: 0;
`
